module.exports = __webpack_public_path__ + "static/media/edit.0d48df30.png";